import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment';

import CalendarCardContainer from './CalendarCardContainer';
import { FORTA_GRAY2 } from '../../../utils/colors';
import { CALENDAR_ROW_DURATION, ROW_HEIGHT } from './constants';

import type { ICalendarData } from './HistoricalDocumentCalendar';
import type { Moment } from 'moment';

interface ICalendarBodyRowProps {
  loading: boolean;
  isFirstRow?: boolean;
  isLastRow?: boolean;
  startHour: number;
  data: ICalendarData[];
  week: [Moment, Moment, Moment, Moment, Moment, Moment, Moment];
}

function CalendarBodyRow({
  isFirstRow,
  isLastRow,
  loading,
  startHour,
  week,
  data,
}: ICalendarBodyRowProps) {
  const [sun, mon, tue, wed, thu, fri, sat] = week;
  const [sunData, monData, tueData, wedData, thuData, friData, satData] = data;

  return (
    <Grid container textAlign={'center'}>
      <Grid
        item
        xs={0.8}
        sx={{ border: `2px solid ${FORTA_GRAY2}`, borderTop: 'none', p: 1, height: ROW_HEIGHT }}
      >
        <Box sx={{ mt: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography fontWeight={700}>
            {moment().hour(startHour).minute(0).second(0).format('hh:mm a')}
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={1.6}
        sx={{
          border: `2px solid ${FORTA_GRAY2}`,
          borderLeft: 'none',
          borderTop: 'none',
          height: ROW_HEIGHT,
        }}
      >
        <CalendarCardContainer
          isFirstRow={isFirstRow}
          isLastRow={isLastRow}
          loading={loading && Boolean(Math.round(Math.random()))}
          startTime={moment(sun).hour(startHour).minute(0).second(0).milliseconds(0)}
          endTime={moment(sun)
            .hour(startHour + CALENDAR_ROW_DURATION)
            .minute(0)
            .second(0)
            .milliseconds(0)}
          data={sunData}
        />
      </Grid>
      <Grid
        item
        xs={1.6}
        sx={{
          border: `2px solid ${FORTA_GRAY2}`,
          borderLeft: 'none',
          borderTop: 'none',
          height: ROW_HEIGHT,
        }}
      >
        <CalendarCardContainer
          isFirstRow={isFirstRow}
          isLastRow={isLastRow}
          loading={loading && Boolean(Math.round(Math.random()))}
          startTime={moment(mon).hour(startHour).minute(0).second(0).milliseconds(0)}
          endTime={moment(mon)
            .hour(startHour + CALENDAR_ROW_DURATION)
            .minute(0)
            .second(0)
            .milliseconds(0)}
          data={monData}
        />
      </Grid>
      <Grid
        item
        xs={1.6}
        sx={{
          border: `2px solid ${FORTA_GRAY2}`,
          borderLeft: 'none',
          borderTop: 'none',
          height: ROW_HEIGHT,
        }}
      >
        <CalendarCardContainer
          isFirstRow={isFirstRow}
          isLastRow={isLastRow}
          loading={loading && Boolean(Math.round(Math.random()))}
          startTime={moment(tue).hour(startHour).minute(0).second(0).milliseconds(0)}
          endTime={moment(tue)
            .hour(startHour + CALENDAR_ROW_DURATION)
            .minute(0)
            .second(0)
            .milliseconds(0)}
          data={tueData}
        />
      </Grid>
      <Grid
        item
        xs={1.6}
        sx={{
          border: `2px solid ${FORTA_GRAY2}`,
          borderLeft: 'none',
          borderTop: 'none',
          height: ROW_HEIGHT,
        }}
      >
        <CalendarCardContainer
          isFirstRow={isFirstRow}
          isLastRow={isLastRow}
          loading={loading && Boolean(Math.round(Math.random()))}
          startTime={moment(wed).hour(startHour).minute(0).second(0).milliseconds(0)}
          endTime={moment(wed)
            .hour(startHour + CALENDAR_ROW_DURATION)
            .minute(0)
            .second(0)
            .milliseconds(0)}
          data={wedData}
        />
      </Grid>
      <Grid
        item
        xs={1.6}
        sx={{
          border: `2px solid ${FORTA_GRAY2}`,
          borderLeft: 'none',
          borderTop: 'none',
          height: ROW_HEIGHT,
        }}
      >
        <CalendarCardContainer
          isFirstRow={isFirstRow}
          isLastRow={isLastRow}
          loading={loading && Boolean(Math.round(Math.random()))}
          startTime={moment(thu).hour(startHour).minute(0).second(0).milliseconds(0)}
          endTime={moment(thu)
            .hour(startHour + CALENDAR_ROW_DURATION)
            .minute(0)
            .second(0)
            .milliseconds(0)}
          data={thuData}
        />
      </Grid>
      <Grid
        item
        xs={1.6}
        sx={{
          border: `2px solid ${FORTA_GRAY2}`,
          borderLeft: 'none',
          borderTop: 'none',
          height: ROW_HEIGHT,
        }}
      >
        <CalendarCardContainer
          isFirstRow={isFirstRow}
          isLastRow={isLastRow}
          loading={loading && Boolean(Math.round(Math.random()))}
          startTime={moment(fri).hour(startHour).minute(0).second(0).milliseconds(0)}
          endTime={moment(fri)
            .hour(startHour + CALENDAR_ROW_DURATION)
            .minute(0)
            .second(0)
            .milliseconds(0)}
          data={friData}
        />
      </Grid>
      <Grid
        item
        xs={1.6}
        sx={{
          border: `2px solid ${FORTA_GRAY2}`,
          borderLeft: 'none',
          borderTop: 'none',
          height: ROW_HEIGHT,
        }}
      >
        <CalendarCardContainer
          isFirstRow={isFirstRow}
          isLastRow={isLastRow}
          loading={loading && Boolean(Math.round(Math.random()))}
          startTime={moment(sat).hour(startHour).minute(0).second(0).milliseconds(0)}
          endTime={moment(sat)
            .hour(startHour + CALENDAR_ROW_DURATION)
            .minute(0)
            .second(0)
            .milliseconds(0)}
          data={satData}
        />
      </Grid>
    </Grid>
  );
}

export default CalendarBodyRow;
